<template>
  <div class="auth-page">
    <div class="auth-page__bg"></div>
    <div class="auth-page__card">
      <img src="/logo.png" alt="Palace of Kebap" class="auth-page__logo" />
      <h2 class="auth-page__title">Passwort vergessen?</h2>
      <p class="auth-page__sub">
        Gib deine E-Mail ein und wir senden dir einen Link zum Zurücksetzen
      </p>

      <form @submit.prevent="onSubmit">
        <div class="auth-input">
          <feather-icon icon="MailIcon" svgClasses="w-5 h-5" />
          <input
            type="email"
            placeholder="Deine E-Mail Adresse"
            v-model="email"
            required
          />
        </div>

        <button type="submit" class="auth-btn auth-btn--primary">
          Link senden
        </button>
        <button
          type="button"
          class="auth-btn auth-btn--outline"
          @click="$router.push('/pages/login')"
        >
          Zurück zum Login
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "../../axios";

export default {
  data() {
    return { email: "" };
  },
  methods: {
    async onSubmit() {
      try {
        await axios.post("/api/auth/forgot-password", { email: this.email });
        this.$vs.notify({
          title: "E-Mail gesendet",
          text: "Prüfe dein Postfach",
          color: "success",
          position: "top-center",
        });
      } catch (error) {
        this.$vs.notify({
          title: "Fehler",
          text: "E-Mail konnte nicht gesendet werden",
          color: "danger",
          position: "top-center",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/auth.scss";
</style>
